import React from 'react';
import styles from './Indicators.module.css';
import ChartIndicators from '../components/ChartIndicators';
import LimitedAdvise from '../components/LimitedAdvise';
import { useSelector } from 'react-redux';

function Indicators(){    

    const { isPremium } = useSelector(state => state.globalData);
         
    return (        
        <div className={styles.main_page}>
            <header className={styles.main_header}>
                <h1>Indicators</h1>
            </header>
            <main>
                <section className={styles.content}>
                    {!isPremium &&
                        <><div style={{ position: 'absolute', right: '8%' }}>
                                <LimitedAdvise
                                    width="80px"
                                    height="20px"
                                    message="Limited"
                                    tooltipTitle="Why this page is limited?"
                                    tooltipPhrases={[
                                        "Up to 10 symbols"                                        
                                    ]}
                                    tooltipPosition="left" /* Options: top, down, left, right */
                                    tooltipWidth='250px' />
                            </div><br /><br /></>
                    }
                    <ChartIndicators/>
                </section>
            </main>            
        </div>
    );
}

export default Indicators;






